<div class="modalspacer">
  <form class="form-vertical">
    <div class="row">
      <div class="col-xs-12">
        <img class="img-responsive" ng-src="/routes/files/filereader/{{ilCtrl.img.fileid}}">
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-9">
        <label for="imglabel">Bildbeschreibung</label>
        <input id="imglabel" type="text" readonly ng-model="ilCtrl.img.label" class="form-control"
               ng-model-options="{ debounce: 2000 }">
      </div>
      <div class="col-xs-12 col-sm-3">
        <label for="imginc">In Befund</label>
        <input id="imginc" type="checkbox" readonly ng-model="ilCtrl.img.include" class="form-control">
      </div>
    </div>
  </form>
</div>